// extracted by mini-css-extract-plugin
export default {"input":"textarea_input__lMkyU","error-input":"textarea_error-input__CeBLi"};